"use strict";

import Swiper from 'swiper';
// import $ from 'jquery';
import 'bootstrap';
import AOS from 'aos';
import ScrollPlay from './ScrollPlay'

window.Swiper = Swiper;
window.AOS = AOS;
window.ScrollPlay = ScrollPlay;

$( document ).ready(function() {
  // AOD
  AOS.init({
    duration: 1000
  });

  // 사이드메뉴
  $(function(){
    var targetControlMenu = $(".container-doc");
    $(".doc-header .btn-menu").on("click", function(){
      targetControlMenu.stop().removeClass("menu-close-animate").addClass("menu-open-animate").addClass("menu-on");
      $("html").addClass("dimmed");
      setTimeout (
        function() {
          targetControlMenu.removeClass("menu-open-animate");
        }, 800
      );
    })
  
    $(".menu-side .btn-close").on("click", function(){
      targetControlMenu.stop().removeClass("menu-open-animate").addClass("menu-close-animate");
      setTimeout (
        function() {
          targetControlMenu.removeClass("menu-on").removeClass("menu-close-animate");
          $("html").removeClass("dimmed");
        }, 600
      );
    })

    var btnMenu = $(".menu-side .link-main, .menu-side .link-submenu")
    btnMenu.on("click", function(){
      var targetUrl = $(this).attr('href');
      targetControlMenu.stop().removeClass("menu-open-animate").addClass("menu-close-animate");
      setTimeout (
        function() {
          targetControlMenu.removeClass("menu-on").removeClass("menu-close-animate");
          $(location).attr("href", targetUrl)
        }, 600
      );
      return false;
    })
    
  });

  window.marquee = {
    init: function () {
      var element = $('.marquee');
      var _this = this;
      element.each(function (i) {
        if (_this.isElementOverflowing(element[i])) {
          _this.wrapContentsInMarquee(element[i]);
        }
      });
  
    },
    isElementOverflowing: function (element) {
      var overflowX = element.offsetWidth < element.scrollWidth - 1;
      //console.log(element.offsetWidth, element.scrollWidth -1);
      return (overflowX);
    },
    wrapContentsInMarquee: function (element) {
      var marquee = document.createElement('div'),
          clone = document.createElement('div'),
          contents = element.innerText;
  
      marquee.className = 'origin';
      marquee.innerText = contents;
      clone.className = 'clone';
      clone.innerText = contents;
      element.innerHTML = '';
      element.appendChild(marquee);
      element.appendChild(clone);
      element.className = 'marquee ani';
      var duration = (marquee.offsetWidth)/50+ 's';
      marquee.style.animationDuration = duration;
      clone.style.animationDuration = duration;
    }  
  }

  // main sns 공유
  $(".kv-share .btn-share").hover(function(){
    $(this).css('display', 'none'); 
    $(".kv-link").css("display","flex");
  }, function(){
    $(this).css("display", "block");
    $(".kv-link").css("display","none");
  });

  $(".kv-link").hover(function(){
    $(this).css('display', 'flex'); 
    $(".kv-share .btn-share").css('display', 'none');
  }, function(){
    $(this).css('display', 'none'); 
    $(".kv-share .btn-share").css('display', 'block');
  });

  // main 알림 버튼 on
  var alarmBtn = document.getElementsByClassName('btn-alarm');
  for(let i = 0; i < alarmBtn.length; i++) {
    alarmBtn[i].addEventListener('click', function(e) {
      e.preventDefault();
      alarmBtn[i].classList.toggle('on');
    });
  }

  if($(".container-doc").hasClass("container-main") === true) {
    $(".side-gnb .list-menu li:first-child").addClass('open');
  }

  $(".side-gnb .list-menu #menu1").hover(function(){
    $(this).next(".list-submenu").slideDown(300); 
    $('.side-gnb .list-menu #menu4').next('.list-submenu').slideUp(300);
  });

  $(".side-gnb .list-menu #menu4").hover(function(){
    $(this).next(".list-submenu").slideDown(300); 
    $(".side-gnb .list-menu #menu1").next('.list-submenu').slideUp(300);
  });

  // scroll animation
  if($(document).scrollTop() > 800 ) {
    $(".doc-footer .btn-top").addClass("active");
  }
  
  $(window).scroll(function(){ 
    // 500스크롤 되었을 경우 메뉴 보임 (메인)
    var _scrollTop = window.scrollY || document.documentElement.scrollTop;

    if(_scrollTop > 800) {
      $(".doc-footer .btn-top").addClass("active");
    } else {
      $(".doc-footer .btn-top").removeClass("active");
    }
  });
  // footer top
  $(function(){
    var topPosition = $(".container-doc").offset().top;
    $(".doc-footer .btn-top").on("click", function(){
      $("html, body").animate({scrollTop:topPosition}, 500);
    })
  });

  // 부문별 투표 메뉴 on,off
  $('.list-menu .link-menu').on('click', function() {
    $('.list-menu li').removeClass('on');
    $(this).parent().addClass('on');
  });

  // 부문별 투표 메뉴 on,off
  $('.list-vote-menu .link-vote-menu').on('click', function() {
    $('.list-vote-menu li').removeClass('on');
    $(this).parent().addClass('on');
  });

  // dropdown
  $('.dropdown').each(function () {
    var that = $(this);
    that.find('.dropdown-toggle .label').text(that.find('.active').text());
    that.find('.dropdown-menu a').on('click', function () {
      that.find('.active').removeClass('active');
      that.find('.dropdown-toggle .label').text($(this).text());
      $(this).addClass('active');
    });
  });

  // $.fn.dropdown.noConflict(); 

  // 공지사항
  $('.notice').on('click','.notice-question',function(e){
		e.preventDefault();
    $(this).next(".notice-answer").slideToggle(100).parents('li').toggleClass('on');
	});
});

